import { render, staticRenderFns } from "./CurveSetting.vue?vue&type=template&id=a3c3fdd2&scoped=true"
import script from "./CurveSetting.vue?vue&type=script&lang=js"
export * from "./CurveSetting.vue?vue&type=script&lang=js"
import style0 from "./CurveSetting.vue?vue&type=style&index=0&id=a3c3fdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3fdd2",
  null
  
)

export default component.exports